import { BASE_API_URL } from "~/helper/apiService";

const normalizedBaseUrl =
  BASE_API_URL && BASE_API_URL.endsWith("/") ? BASE_API_URL : `${BASE_API_URL || ""}/`;

export const API_BASE = `${normalizedBaseUrl}api`;

// Helper fetch với credentials và tự động redirect khi hết phiên
export async function fetchWithAuth(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  // Kiểm tra nếu response là 401 (Unauthorized) hoặc 403 (Forbidden)
  // và redirect về trang login nếu đang ở trong revenue app
  if ((response.status === 401 || response.status === 403) && window.location.pathname.includes('/revenue')) {
    // Chỉ redirect nếu đang ở trong revenue app
    window.location.href = '/login';
    return response;
  }

  return response;
}

